import { get } from "lodash";
export default (function (user) {
    var firstname = get(user, "firstname");
    var lastname = get(user, "lastname");
    return "" + firstname + (lastname ? " " + lastname : "");
});
